// src/components/Footer.js

import React from 'react';
import { motion } from 'framer-motion'; // <-- Framer Motion Import
import { Link } from 'react-router-dom';
import './Footer.css'; // Assume you move styles here for a cleaner component

// Example data for a modern, multi-column footer
const footerLinks = [
  { title: 'Product', links: ['Roadmaps', 'Explore', 'Pricing'] },
  { title: 'Company', links: ['About Us', 'Careers', 'Contact'] },
  { title: 'Resources', links: ['Help Center', 'Blog', 'Privacy Policy'] },
];

// Animation Variants for the entire footer
const footerVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
        opacity: 1,
        y: 0,
        transition: {
            duration: 0.6,
            ease: "easeOut"
        }
    }
};

const Footer = () => {
  return (
    // 1. Replace footer tag with motion.footer and add animation props
    <motion.footer 
      className="site-footer"
      variants={footerVariants}
      initial="hidden"
      // 2. Trigger animation when scrolled into view
      whileInView="visible"
      // 3. Trigger late (80% visibility) and only once
      viewport={{ once: true, amount: 0.8 }}
    >
        <div className="footer-content-wrapper">
            {/* ----------------- MODERN FOOTER STRUCTURE ----------------- */}
            
            <div className="footer-grid">
                {/* Logo/Brand Section */}
                <div className="footer-brand">
                    <h3>Blue Print</h3>
                    <p className="tagline">Personalized paths to success.</p>
                </div>

                {/* Link Sections */}
                {footerLinks.map((section) => (
                    <div key={section.title} className="footer-section">
                        <h4>{section.title}</h4>
                        <ul>
                            {section.links.map((link) => (
                                <li key={link}>
                                    {/* Using simple '#' for placeholder links */}
                                    <Link to={`/${link.toLowerCase().replace(' ', '-')}`}>{link}</Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                ))}
            </div>

            {/* ----------------- COPYRIGHT AND LEGAL ----------------- */}
            <div className="footer-bottom">
                <p>&copy; {new Date().getFullYear()} Blue Print Platform. All rights reserved.</p>
            </div>
        </div>
    </motion.footer>
  );
};

export default Footer;